import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {ApplicationProduct} from "../types.ts";
import {useApplicationProduct} from "../hooks/useApplicationProduct.ts";
import {useParams} from "react-router-dom";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: applicationId} = useParams();

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    const {
        record,
        createRecord,
    } = useApplicationProduct(applicationId);

    return (
        <FormDrawer
            record={record ?? {} as ApplicationProduct}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
